// TEMPORARY: Braze push sync — remove when legacy facility app is sunset.
import { registerPlugin } from "@capacitor/core";
import { Platform } from "@src/mobile/utils/platform";

interface BrazePushSyncPlugin {
  changeUser(options: { userId: string }): Promise<void>;
  registerPushToken(options: { token: string }): Promise<void>;
}

const BrazePushSync = registerPlugin<BrazePushSyncPlugin>("BrazePushSync");

/**
 * Tells the legacy native Braze SDK which user is signed in. No-op on web.
 */
export async function brazePushSyncChangeUser(userId: string): Promise<void> {
  if (!Platform.isMobile) {
    return;
  }
  await BrazePushSync.changeUser({ userId });
}

/**
 * Forwards a push token to the legacy native Braze SDK. No-op on web.
 */
export async function brazePushSyncRegisterToken(token: string): Promise<void> {
  if (!Platform.isMobile) {
    return;
  }
  await BrazePushSync.registerPushToken({ token });
}
